import { Activity } from "@api/graphql/generated/generated-types";

export function getActivityUpdater(activity: Activity): string | null {
  if (activity.updatedByUser) {
    return activity.updatedByUser.email ?? null;
  }

  if (activity.updatedByDriver) {
    const { firstName, lastName, email } = activity.updatedByDriver;
    const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();

    if (firstName || lastName) {
      return fullName;
    }

    return email ?? (fullName || null);
  }

  if (activity.updatedByEndCustomer) {
    if (activity.updatedByEndCustomer.companyName) {
      return activity.updatedByEndCustomer.companyName;
    }
    const name = `${activity.updatedByEndCustomer.firstName ?? ""} ${
      activity.updatedByEndCustomer.lastName ?? ""
    }`.trim();
    return activity.updatedByEndCustomer.contactEmail ?? (name || null);
  }

  if (activity.updatedByEndUser) {
    const name = `${activity.updatedByEndUser.firstName ?? ""} ${
      activity.updatedByEndUser.lastName ?? ""
    }`.trim();
    return activity.updatedByEndUser.email ?? (name || null);
  }

  if (activity.updatedByEmail) {
    return activity.updatedByEmail;
  }

  return null;
}
